<template>
  <div class="main-container">
    <h2 class="text-center mb-4">在线充值(秒到账,送宣传币)</h2>
    
    <!-- 充值方式切换 -->
    <div class="tab-button-container">

      <button class="btn btn-primary" :class="{ active: activeTab === 'custom' }" id="custom-tab" data-bs-toggle="tab" 
              data-bs-target="#custom-tab-pane" type="button" @click="activeTab = 'custom'">充值元宝比例1:{{ productYB.count }}
        <span v-if="activeTab === 'custom'" class="check-mark">√</span>
      </button>
    </div>

    <div class="tab-content">

  

      <!-- 自定义充值 -->
      <div class="tab-pane fade" :class="{ 'show active': activeTab === 'custom' }" id="custom-tab-pane">
        <form id="customAmountForm">
          <div class="mb-3">
            <label class="form-label">充值金额（元）</label>
            <input type="number" class="form-control" id="amountInput" v-model="amount" min="10" max="20000" step="1" required>
            <div id="amountError" class="text-danger" v-if="amountError">请输入10到20000之间的金额</div>
          </div>
        </form>
      </div>
    </div>

    <!-- 独立出来的支付方式和提交按钮 -->
    <div class="fixed-bottom-section">
      <div class="mb-4">
        <label class="form-label">充值账号</label>
        <input type="text" class="form-control" id="accountInput" v-model="account" required @input="checkAccountMatch" @blur="checkAccountMatch">
      </div>
      <div class="mb-4">
        <label class="form-label">确认充值账号</label>
        <input type="text" class="form-control" id="confirmAccountInput" v-model="confirmAccount" required @input="checkAccountMatch" @blur="checkAccountMatch">
        <div id="accountMismatchError" class="text-danger" v-if="accountMismatchError">账号不一致，请重新输入</div>
      </div>
      <div class="payment-method mb-4">
        <div class="mb-2 text-start">支付方式选择：</div>
        <div class="d-flex justify-content-between gap-2">
          <button type="button" class="btn btn-outline-success" :class="{ active: paymentMethod === 'wechat' }" data-method="wechat" @click="selectPaymentMethod('wechat')">
            <img src="../assets/img/wxpay.png" alt="微信支付" style="height: 24px; width: 24px; margin-right: 5px;">
            微信支付
            <span v-if="paymentMethod === 'wechat'" class="check-mark">√</span>
          </button>
          <button type="button" class="btn btn-outline-primary" :class="{ active: paymentMethod === 'alipay' }" data-method="alipay" @click="selectPaymentMethod('alipay')">
            <img src="../assets/img/alipay.png" alt="支付宝" style="height: 24px; width: 24px; margin-right: 5px;">
            支付宝
            <span v-if="paymentMethod === 'alipay'" class="check-mark">√</span>
          </button>
        </div>
      </div>
      <button :disabled="payBtnDisabled" type="button" class="btn btn-primary w-100" id="submitBtn" @click="submitForm">立即充值</button>
    </div>
    <!-- 微信支付二维码 -->
    <el-dialog
      :visible.sync="codeDialogVisible"
      :show-close="false"
      @close="closeDialog"
      width="350px"
      center
    >
      <qriously :value="codeUrl" :size="300" />
      <!-- <img src="../assets/img/code.png" alt="" style="width:100%"><br> -->
      使用微信扫码支付
    </el-dialog>
  </div>
</template>

<script>
import productApi from '../api/product' // 添加产品API导入
import wxPayApi from '../api/wxPay'
import aliPayApi from '../api/aliPay'
import orderInfoApi from '../api/orderInfo'

export default {
  data() {
    return {
      payBtnDisabled: false, //确认支付按钮是否禁用
      activeTab: 'custom', // 当前激活的tab，初始为自定义充值
      amount: '', // 自定义充值金额
      amountError: false, // 自定义充值金额错误提示
      account: '', // 充值账号
      confirmAccount: '', // 确认充值账号
      accountMismatchError: false, // 账号不一致错误提示
      paymentMethod: 'wechat', // 当前选中的支付方式，默认为微信支付
      selectedProductIndex: 0, // 当前选中的套餐索引
      products: [], // 商品列表
      productYB: {}, // 元宝比例
      productId: 3,
      productType: '44072',
      codeDialogVisible: false, // 微信支付二维码弹窗
      codeUrl: '', // 二维码
      orderNo: '', // 订单号
      timer: null, // 定时器
    };
  },
  created() {
    this.fetchProducts(); // 在组件创建时获取商品列表
    this.fetchProductYB();
  },
  methods: {
    fetchProducts() { // 获取商品列表的方法
      productApi.list().then((response) => {
        this.products = response.data.productList;
      }).catch((error) => {
        console.error('获取商品列表失败:', error);
      });
    },
    fetchProductYB() { // 获取元宝商品的方法
      productApi.listYB().then((response) => {
        this.productYB = response.data.productYB;
      }).catch((error) => {
        console.error('获取元宝商品失败:', error);
      });
    },
    checkAccountMatch() {
      // 检查充值账号和确认充值账号是否一致
      if (this.account !== this.confirmAccount) {
        this.accountMismatchError = true;
      } else {
        this.accountMismatchError = false;
      }
    },
    selectPaymentMethod(method) {
      // 选择支付方式
      this.paymentMethod = method;
    },
    selectProduct(index) {
      // 选择套餐
      this.selectedProductIndex = index;
    },
    submitForm() {
      // 提交表单
      if (!this.account || !this.confirmAccount) {
        alert('请填写充值账号');
        return;
      }

      if (this.account !== this.confirmAccount) {
        this.accountMismatchError = true;
        return;
      } else {
        this.accountMismatchError = false;
      }

      let paymentPromise;
      if (this.activeTab === 'custom') {
        if (!this.amount) {
          alert('请填写充值金额');
          return;
        }
        if (this.amountError) {
          alert('充值金额有误!范围10-20000之间输入');
          return;
        }
        //禁用按钮，防止重复提交
        this.payBtnDisabled = true
        // 调用微信支付接口
        if (this.paymentMethod === 'wechat') {
          paymentPromise = wxPayApi.nativePay(this.productId, this.account,this.amount);
        } 
        // 调用支付宝支付接口
        else if (this.paymentMethod === 'alipay') {
          paymentPromise = aliPayApi.tradePagePay(this.productId, this.account,this.amount);
        }
      } else {
        if (this.selectedProductIndex === null) {
          alert('请选择一个套餐');
          return;
        }

        const product = this.products[this.selectedProductIndex];

        // 调用微信支付接口
        if (this.paymentMethod === 'wechat') {
          paymentPromise = wxPayApi.nativePay(product.id, this.account,1);
        } 
        // 调用支付宝支付接口
        else if (this.paymentMethod === 'alipay') {
          paymentPromise = aliPayApi.tradePagePay(product.id, this.account,1);
        }
      }

      if (paymentPromise) {
        paymentPromise.then((response) => {
          if (this.paymentMethod === 'wechat') {
            this.codeUrl = response.data.codeUrl;
            this.orderNo = response.data.orderNo;

            // 打开二维码弹窗
            this.codeDialogVisible = true;

            // 启动定时器
            this.timer = setInterval(() => {
              // 查询订单是否支付成功
              this.queryOrderStatus();
            }, 3000);
          } else if (this.paymentMethod === 'alipay') {
            // 将支付宝返回的表单字符串写在浏览器中，表单会自动触发submit提交
            document.write(response.data.formStr);
          }
        }).catch((error) => {
          console.error('支付失败:', error);
          alert('支付失败，请重试');
        });
      }
    },

    // 关闭微信支付二维码对话框时让“确认支付”按钮可用
    closeDialog() {
      console.log('close.................');
      this.payBtnDisabled = false
      this.codeDialogVisible = false;
      console.log('清除定时器');
      clearInterval(this.timer);
    },

    // 查询订单状态
    queryOrderStatus() {
      orderInfoApi.queryOrderStatus(this.orderNo).then((response) => {
        console.log('查询订单状态：' + response.code);

        // 支付成功后的页面跳转
        if (response.code === 0) {
          console.log('清除定时器');
          clearInterval(this.timer);
          // 三秒后跳转到支付成功页面
          setTimeout(() => {
            this.$router.push({ path: '/success' });
          }, 3000);
        } else if (response.code === 102) {
          // 超时已关闭
          this.closeDialog();
        }
      }).catch((error) => {
        console.error('查询订单状态失败:', error);
      });
    },
  },
  watch: {
    amount(newVal) {
      // 强制整数转换
    if (newVal && newVal.toString().includes('.')) {
      this.amount = parseInt(newVal);
      return
    }
      // 监听充值金额输入框的输入事件
      if (newVal < 10 || newVal > 20000) {
        this.amountError = true;
      } else {
        this.amountError = false;
      }
    }
  }
};
</script>

<style scoped>
.main-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 20px;
}
.payment-method .btn {
  width: 48%;
  transition: all 0.3s ease;
}
.payment-method .btn.active {
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}
.product-card {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}
.product-card.active {
  border-color: #0d6efd;
  background-color: #0d6efd;
  color: white;
}
.fixed-bottom-section {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}
.tab-button-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}
.tab-button-container button {
  margin: 0 0.5rem;
  width: 100%;
  position: relative;
  background-color: #e9ecef; /* 修改未选择状态下的按钮背景颜色 */
  color: #333; /* 修改未选择状态下的按钮文字颜色为深灰色 */
  border: none; /* 移除边框 */
}
.tab-button-container button.active {
  background-color: #004085; /* 修改激活状态下的按钮背景颜色 */
  color: white; /* 保持激活状态下的按钮文字颜色为白色 */
}
.check-mark {
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 16px;
  color: #ffffff;
}
</style>